import React, { useEffect, useRef, useState } from 'react'
import { ReactComponent as Chevron } from '../../../../Components/icons/triangle.svg'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import usePopup from '../../hooks/usePopup'
import { ModalWindow } from '../../../../Components/GeneralComponents/ModalWindow/ModalWindow'

export default function RolesSelect({
  options,
  defaultOption,
  onOptionSelect = () => console.log('select'),
  userId,
  groupId,
  disabled = false,
  ...rest
}) {
  const { openPopup, closePopup, isOpen: isOpenPopup } = usePopup()
  const roleRef = useRef(defaultOption)
  const selectRef = useRef(null)
  const [selectedOption, setSelectedOption] = useState(defaultOption || null)
  const [pendingOption, setPendingOption] = useState(null)
  const [isOpen, setIsOpen] = useState(false)

  // Toggle the dropdown when clicking the select element
  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleOptionClick = option => {
    if (option === roleRef.current) {
      return
    }
    if (
      roleRef.current === 'Organization Owner' ||
      roleRef.current === 'Organization Administrator' ||
      option === 'Organization Owner' ||
      option === 'Organization Administrator'
    ) {
      setPendingOption(option)
      openPopup()
    } else {
      onOptionSelect({
        role: option,
        organization_users: [userId],
        g_f_id: groupId,
        oldRole: roleRef.current,
      })
      roleRef.current = option
      setSelectedOption(option)
      setIsOpen(false)
    }
  }

  const handleOptionConfirm = () => {
    if (!pendingOption) return
    onOptionSelect({
      role: pendingOption,
      organization_users: [userId],
      g_f_id: groupId,
      oldRole: roleRef.current,
    })
    roleRef.current = pendingOption
    setSelectedOption(pendingOption)
    setPendingOption(null)
    closePopup()
    setIsOpen(false)
  }

  useEffect(() => {
    setSelectedOption(defaultOption)
  }, [defaultOption])

  // Close the dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  return (
    <div className={classes.wrapper} {...rest}>
      <div className={classes['custom-select']} ref={selectRef}>
        <button
          type="button"
          disabled={disabled}
          className={classes['select-box']}
          onClick={toggleDropdown}
        >
          {selectedOption}
          {!disabled ? (
            <Chevron
              className={`${classes.chevron} ${
                isOpen ? classes.chevron__active : ''
              }`.trim()}
            />
          ) : null}
        </button>

        {isOpen && (
          <ul className={classes['options-list']}>
            {options.map((option, index) => (
              <li
                key={index}
                className={`${classes['option-item']} ${
                  option === selectedOption ? classes['selected'] : ''
                }`.trim()}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </li>
            ))}
          </ul>
        )}
        <ModalWindow
          open={isOpenPopup}
          rounded={true}
          disableCloseIcon={true}
          onClose={() => {
            closePopup()
          }}
        >
          <div className={classes.modal}>
            <p className={classes['modal-title']}>
              {pendingOption === 'Organization Owner' ||
              pendingOption === 'Organization Administrator'
                ? `Add ${pendingOption === 'Organization Owner' ? 'Owner' : 'Administrator'} Access`
                : `Remove ${selectedOption === 'Organization Owner' ? 'Owner' : 'Administrator'} Access`}
            </p>
            <p className={classes['modal-subtitle']}>
              {pendingOption === 'Organization Owner' ||
              pendingOption === 'Organization Administrator'
                ? `Please confirm you want to grant this user ${pendingOption} permissions`
                : `Please confirm you want to remove this user's ${selectedOption} permissions`}
            </p>
            <div className={classes['modal-actions']}>
              <button
                className={`${classes['modal-button']} ${classes['modal-button--confirm']}`}
                onClick={handleOptionConfirm}
              >
                Confirm
              </button>
              <button
                className={`${classes['modal-button']} ${classes['modal-button--cancel']}`}
                onClick={() => {
                  closePopup()
                  setIsOpen(false)
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </ModalWindow>
      </div>
    </div>
  )
}

RolesSelect.propTypes = {
  options: PropTypes.array,
  defaultOption: PropTypes.string,
  onOptionSelect: PropTypes.func,
  disabled: PropTypes.bool,
  userId: PropTypes.any,
  groupId: PropTypes.any,
}
